const filterWipTickets = (tickets, groupId, typeId, preBstype, BSType) => {
    
    // Helper function to extract ticket details
   const getTicketDetails = (ticket) => ({
        FK_IIL_CUSTOMER_TICKETS_ID: ticket?.FK_IIL_CUSTOMER_TICKETS_ID,
        MAIL_SENT_COUNTER: ticket?.MAIL_SENT_COUNTER,
        FK_GROUP_ID: ticket?.FK_GROUP_ID,
        FK_TYPE_ID: ticket?.FK_TYPE_ID,
    });

    // Handle pre-BS type tickets
    if (preBstype) {
        const preBsTicket = tickets.find((ticket) => ticket?.FK_TYPE_ID === '306');
        if (preBsTicket) return getTicketDetails(preBsTicket);
    }

    // Handle BS type tickets
    if (BSType) {
        const bsTicket = tickets.find((ticket) => ticket?.FK_TYPE_ID === '181');
        if (bsTicket) return getTicketDetails(bsTicket);
    }

    // Handle for specific typeId 312
    if (typeId === '312') {
        const specificTicket = tickets.find((ticket) => ticket?.FK_TYPE_ID === typeId);
        if (specificTicket) return getTicketDetails(specificTicket);
    }

    // General filtering for typeId and groupId

    const filteredTicket = tickets.filter(
        (ticket) =>
            ticket?.FK_GROUP_ID === String(groupId)
    );

    if (filteredTicket.length > 0) {
        return filteredTicket.map(getTicketDetails);
    }

    // Fallback to the first ticket in the list
    return {
        FK_IIL_CUSTOMER_TICKETS_ID: tickets[0]?.CUSTOMER_TICKET_ID,
        MAIL_SENT_COUNTER: tickets[0]?.MAIL_SENT_COUNTER,
        FK_GROUP_ID: tickets[0]?.FK_GROUP_ID,
        FK_TYPE_ID: tickets[0]?.FK_TYPE_ID,
    };
};

export default filterWipTickets;
